import PageHeader from "src/components/PageHeader";
import PageStack from "src/components/PageStack/PageStack";
import { useT } from "src/internationalization";

import CustomersTable from "./CustomersTable";

export default function CustomersPage() {
  const t = useT();

  return (
    <PageStack>
      <div className="flex items-center">
        <PageHeader className="ml-0">{t("page.customers.title")}</PageHeader>
      </div>
      <div className="mt-5">
        <CustomersTable />
      </div>
    </PageStack>
  );
}
